import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface PathState {
  currentPath: string | null;
  previousPath: string | null;
  noPreviousPath: string | null;
  setPath: (path: string) => void;
  resetPath: () => void;
}

export const usePathStore = create<PathState>()(
  persist(
    (set) => ({
      currentPath: null,
      previousPath: null,
      noPreviousPath: null,
      setPath: (path: string) =>
        set((state) => ({
          currentPath: path,
          previousPath: state.currentPath,
          noPreviousPath: state.currentPath === null ? path : state.noPreviousPath,
        })),
      resetPath: () =>
        set(() => ({
          currentPath: null,
          previousPath: null,
          noPreviousPath: null,
        })),
    }),
    {
      name: 'path-storage',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
